// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { type CardBrand } from '@tectonics/prs/card-brand';

import genericFrontImageSrc from './images/card-generic-front.svg';
import amexImageSrc from './images/card-amex.svg';
import carnetImageSrc from './images/card-carnet.svg';
import dinersImageSrc from './images/card-diners.svg';
import discoverImageSrc from './images/card-discover.svg';
import eloImageSrc from './images/card-elo.svg';
import hipercardImageSrc from './images/card-hipercard.svg';
import mastercardImageSrc from './images/card-mastercard.svg';
import visaImageSrc from './images/card-visa.svg';
import privateLabelImageSrc from './images/private-label.svg';
import naranjaImageSrc from './images/card-naranja.svg';
import codensaImageSrc from './images/card-codensa.png';
import rupayImageSrc from './images/card-rupay.svg';

type Props = {|
  brand: ?CardBrand,
|};

export function CardIcon({ brand }: Props): Node {
  return (
    <CardImage src={resolveSrc(brand)} alt="Card icon" />
  );
}

const CardImage = styled.img``;

function resolveSrc(brand: ?CardBrand): string {
  switch (brand) {
    case 'amex':
      return amexImageSrc;

    case 'carnet':
      return carnetImageSrc;

    case 'diners':
      return dinersImageSrc;

    case 'discover':
      return discoverImageSrc;

    case 'elo':
      return eloImageSrc;

    case 'hipercard':
      return hipercardImageSrc;

    case 'mastercard':
      return mastercardImageSrc;

    case 'visa':
      return visaImageSrc;

    case 'private':
      return privateLabelImageSrc;

    case 'naranja':
      return naranjaImageSrc;

    case 'codensa':
      return codensaImageSrc;

    case 'rupay':
      return rupayImageSrc;

    default:
      return genericFrontImageSrc;
  }
}
